var map = {
	"./accelerate.json": 98362,
	"./alert.json": 30383,
	"./animate.json": 7038,
	"./animateOnce.json": 20493,
	"./change-by.json": 15287,
	"./clone.json": 77206,
	"./collide.json": 48991,
	"./complete.json": 57006,
	"./destroy.json": 62054,
	"./error.json": 56480,
	"./explode.json": 30527,
	"./fail.json": 86975,
	"./feedback.json": 38780,
	"./flip.json": 61451,
	"./friction.json": 93824,
	"./get.json": 53951,
	"./hide.json": 82241,
	"./journey-move.json": 82011,
	"./jump.json": 60009,
	"./match-to.json": 58154,
	"./matchPointerPosition.json": 78999,
	"./move-through.json": 28003,
	"./move-towards.json": 73790,
	"./move.json": 27026,
	"./play.json": 30184,
	"./random-position.json": 29557,
	"./random-x-position.json": 98824,
	"./random-y-position.json": 69113,
	"./rotationStyle.json": 40656,
	"./set.json": 65982,
	"./shake.json": 71519,
	"./show.json": 17673,
	"./step.json": 95441,
	"./stop.json": 73503,
	"./stopAnimation.json": 51968,
	"./stopSound.json": 23028,
	"./time.json": 58212,
	"./turn.json": 44336,
	"./wait.json": 9450,
	"./warning.json": 73463,
	"models/block/blocks/command/blueprints/accelerate.json": 98362,
	"models/block/blocks/command/blueprints/alert.json": 30383,
	"models/block/blocks/command/blueprints/animate.json": 7038,
	"models/block/blocks/command/blueprints/animateOnce.json": 20493,
	"models/block/blocks/command/blueprints/change-by.json": 15287,
	"models/block/blocks/command/blueprints/clone.json": 77206,
	"models/block/blocks/command/blueprints/collide.json": 48991,
	"models/block/blocks/command/blueprints/complete.json": 57006,
	"models/block/blocks/command/blueprints/destroy.json": 62054,
	"models/block/blocks/command/blueprints/error.json": 56480,
	"models/block/blocks/command/blueprints/explode.json": 30527,
	"models/block/blocks/command/blueprints/fail.json": 86975,
	"models/block/blocks/command/blueprints/feedback.json": 38780,
	"models/block/blocks/command/blueprints/flip.json": 61451,
	"models/block/blocks/command/blueprints/friction.json": 93824,
	"models/block/blocks/command/blueprints/get.json": 53951,
	"models/block/blocks/command/blueprints/hide.json": 82241,
	"models/block/blocks/command/blueprints/journey-move.json": 82011,
	"models/block/blocks/command/blueprints/jump.json": 60009,
	"models/block/blocks/command/blueprints/match-to.json": 58154,
	"models/block/blocks/command/blueprints/matchPointerPosition.json": 78999,
	"models/block/blocks/command/blueprints/move-through.json": 28003,
	"models/block/blocks/command/blueprints/move-towards.json": 73790,
	"models/block/blocks/command/blueprints/move.json": 27026,
	"models/block/blocks/command/blueprints/play.json": 30184,
	"models/block/blocks/command/blueprints/random-position.json": 29557,
	"models/block/blocks/command/blueprints/random-x-position.json": 98824,
	"models/block/blocks/command/blueprints/random-y-position.json": 69113,
	"models/block/blocks/command/blueprints/rotationStyle.json": 40656,
	"models/block/blocks/command/blueprints/set.json": 65982,
	"models/block/blocks/command/blueprints/shake.json": 71519,
	"models/block/blocks/command/blueprints/show.json": 17673,
	"models/block/blocks/command/blueprints/step.json": 95441,
	"models/block/blocks/command/blueprints/stop.json": 73503,
	"models/block/blocks/command/blueprints/stopAnimation.json": 51968,
	"models/block/blocks/command/blueprints/stopSound.json": 23028,
	"models/block/blocks/command/blueprints/time.json": 58212,
	"models/block/blocks/command/blueprints/turn.json": 44336,
	"models/block/blocks/command/blueprints/wait.json": 9450,
	"models/block/blocks/command/blueprints/warning.json": 73463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4958;